// src/layouts/PublicLayout.js
import React from 'react';
import Navbar from '../components/Navbar';
import FooterSection from '../components/Footer';
import { Outlet } from 'react-router-dom';

const PublicLayout = () => (
  <>
    <Navbar />
    <Outlet />
    <FooterSection />
  </>
);

export default PublicLayout;
